<!--
 * @Author: likk
 * @Date: 2023-09-05 17:53:00
 * @LastEditTime: 2024-03-22 02:50:26
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 
-->
<template>
    <el-main class="business-area">
        <div class="top-wrap">
        <Bread></Bread>
        </div>
        <div class="main">
        <div class="top-tit">
            作业服务信息
        </div>
        <div class="content">
            <div class="top">
            <div class="btns" v-if="detail.auditStatus==10">
                <el-button type="primary" @click="handleAudit(20)">通过</el-button>
                <el-button type="primary" @click="handleRefuse()" class="btn-yell">不通过</el-button>
            </div>
            </div>
            <table class="table-info" width="100%" cellspacing="0">
            <tr>
                <td width="10%" class="title">服务方名称</td>
                <td width="18%" class="info">{{ detail.ownerPlainName }}</td>
                <td width="10%" class="title">联系电话</td>
                <td width="18%" class="info">{{ detail.contactPlainPhone }}</td>
                <td width="10%" class="title">发布时间</td>
                <td width="18%" class="info">{{ detail.releaseTime }}</td>
            </tr>
            <tr>
                <td width="10%" class="title">作业类型</td>
                <td width="18%" class="info" colspan="5">{{ detail.workTypeNames }}</td>
            </tr>
            <tr>
                <td width="10%" class="title">作业地区</td>
                <td width="18%" class="info" colspan="5">{{ detail.workAreaNames }}</td>
            </tr>
            </table>
            <div class="map-box" id="mapBox"></div>
            <div class="tit-bott-bor"><span>农机信息</span></div>
            <table class="table-info table-tb" width="100%" cellspacing="0">
            <tr>
                <td width="17%" class="title">农机品目</td>
                <td width="17%" class="title">品牌</td>
                <td width="17%" class="title">型号</td>
                <td width="17%" class="title">购机日期</td>
                <td width="20%" class="title">出厂编号</td>
                <td width="20%" class="title">北斗终端编号</td>
                <td width="12%" class="title">照片</td>
            </tr>
            <tr v-for="(item,index) in machineRefList" :key="index">
                <td width="10%" class="info">{{item.machineName}}</td>
                <td width="18%" class="info">{{item.brandName}}</td>
                <td width="10%" class="info">{{item.modelName}}</td>
                <td width="18%" class="info">{{item.buyDate}}</td>
                <td width="18%" class="info">{{item.factoryCode}}</td>
                <td width="18%" class="info">{{item.imei}}</td>
                <td width="18%" class="info"><img class="thumb-machine" :src="item.machinePhotos"/></td>
            </tr>
            </table>
        </div>
        <AuditRefuseDialog ref="refuseDialog" @submit="refuseReasonSubmit"></AuditRefuseDialog>
        </div>
    </el-main>
</template>

<script>
  import TalksMap from "@/utils/initMapTalks.js";
  import * as maptalks from "maptalks";
  import AuditRefuseDialog from "../components/AuditRefuseDialog";
  import{workServiceDetail,workServiceAudit} from "@/api/gxInfo";
  export default {
    name:"",
    data(){
      return {
        id: "",
        detail:{},
        machineRefList:[],//农机信息
        TalksMapDialog: new TalksMap(),
      }
    },
    components:{
      AuditRefuseDialog
    },
    created(){
      this.id = this.$route.query.id;
      this.getDetail();

    },
    mounted(){
      this.mapInit();
    },
    methods:{
      /**
       * @Author: likk
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
       mapInit(){
        this.TalksMapDialog.init("mapBox", 16);
      },
      /**
       * @Author: likk
       * @description: 向地图上添加自定义标注
       * @param {*}
       * @return {*}
       */      
      addMarkerToMap(lng,lat,address){
        this.TalksMapDialog.map.setCenter({x:lng,y:lat});
        this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
          this.TalksMapDialog.map
        );
        const marker = new maptalks.Marker(
          [lng,lat],
          {
            symbol: [
              {
                markerFile: require("@/assets/gx/biaozhu_dingwei.png"),
                markerWidth: 22,
                markerHeight: 32,
                markerOpacity: 1,
                // info:{
                //   address
                // }
              },
            ],
          }
        ).addTo(this.pic1Marker);
        // marker.on("click", (e) => {
          // let info = e.target._symbol[0].info;
          let content = `<div style='font-size:14px;color:#323333'>农机位置：${address}</div>`
          marker.setInfoWindow({
            single: false,
            content,
          });
          marker.openInfoWindow();
        // });
        
      },
      /**
       * @Author: likk
       * @description: 获取详情数据
       * @param {*}
       * @return {*}
       */ 
      async getDetail(){
        const { data: { result } } = await workServiceDetail(this.id);
        let { machineRefList, ...detail } = result;
        this.detail = detail;
        this.machineRefList = machineRefList;
        this.addMarkerToMap(result.lng,result.lat,detail.workAddress);
      },
      /**
       * @Author: likk
       * @description: 审核
       * @param {Number} auditStatus 20:通过 30：不通过
       * @param {String} refuseReason 不通过理由 非必传
       * @return {*}
       */     
       handleAudit(auditStatus,refuseReason){
          workServiceAudit({
            auditStatus,
            id:this.id,
            refuseReason
          }).then( () => {
            this.$message.success('审核成功');
            this.$router.go(-1);
          })
        },  
        /**
         * @Author: likk
         * @description: 不通过
         * @param {*}
         * @return {*}
         */
         handleRefuse(){
          this.$refs.refuseDialog.handleVisible(true);
         },            
        /**
         * @Author: likk
         * @description: 不通过原因提交
         * @param {*}
         * @return {*}
         */        
        refuseReasonSubmit(data){
          this.handleAudit(30,data);
        }

    }
  }
</script>

<style lang="scss" scoped>
@import "../../style.scss";
.main{
  .top-tit{
    height: 56px;
    line-height: 56px;
    font-size: 20px;
    color: #018388;
    font-weight: bold;
    border-bottom: 1px solid #EFEFEF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back{
      font-size: 16px;
      color: #999999;
      font-weight: normal;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      img{
        height: 16px;
        margin-right: 3px;
      }
    }
  }
  .content{
    .top{
      padding: 10px 0 0px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btns{
        .el-button{
          font-size: 16px;
          width: 80px;
          height: 40px;
          text-align: center;
          padding: 0;
          &.btn-yell{
            background: #E24E20;
            border-color: #E24E20;
          }
        }
      };
    }
    .plate-status{
      display: flex;
      align-items: center;
      margin: 15px 0;
      .icon{
        width: 68px;
        height: 68px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .info{
        margin-left: 15px;
        .name{
          font-size: 20px;
          color: #212121;
        }
        .remark{
          font-size: 16px;
          color: #666666;
          margin-top: 5px;
        }
      }
    }
    .map-box{
      width: 100%;
      height: 400px;
      position: relative;
    }
    table{
      
      &.table-tb{
        tr{
          td{
            text-align: center;
            .thumb-machine{
              width: auto;
              height: 40px;
            }
          }
        }
      }
    }
    .tit-bott-bor{
      margin: 15px 0;
      span{
        font-size: 18px;
        color: #018388;
        border-bottom: 4px solid #018388;
        padding-bottom: 5px;
      }
    }
  }
}
</style>
